import { Column } from "primereact/column";
import useUrlState from "@ahooksjs/use-url-state";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaDataTable from "../../../../components/MeaDataTable";
import CreateCourseModal from "./AddMemberModal";
import membersAPI from "../../../../services/members";
import MeaMemberAvatar from "../../../../components/MeaMemberAvatar";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import MeaButton from "../../../../components/MeaButton";
import { PERMISSION_SCHOOL_MEMBERS } from "../../../../permissions";
import { ListBox } from "primereact/listbox";
import { Dropdown } from "primereact/dropdown";
import { confirmPopup, ConfirmPopup } from "primereact/confirmpopup";
import { Toast } from "primereact/toast";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../../../hooks/useAuthContext";

const MembersListComponent = forwardRef((props, ref) => {
  const { showAddButton, filter } = props;
  const { hasPermission, currentMembership } = useAuthContext();
  const params = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  const schoolId = params?.schoolId || currentMembership?.school_id;
  const trainingId = params?.trainingId;
  const accessToken = "";
  //
  const toast = useRef(null);
  const createModalRef = useRef();
  //
  const [selectedTab, setSelectedTab] = useState(0);
  const [state, setState] = useUrlState({
    membersPage: "1",
    membersPageSize: "30",
    membersFilter: JSON.stringify({
      type: filter?.type || "all",
      name: filter?.name || "",
      phone: filter?.phone || "",
      email: filter?.email || "",
    }),
  });

  const setFilter = (field, value) => {
    let currentFilter = state?.membersFilter;
    let currentFilterObj = JSON.parse(currentFilter);
    currentFilterObj[field] = value;
    setState((s) => ({
      membersPage: 1,
      membersFilter: JSON.stringify(currentFilterObj),
    }));
  };
  //
  useEffect(() => {
    switch (JSON.parse(state.membersFilter)?.type) {
      case "all":
        setSelectedTab(0);
        break;
      case "admin,owner":
        setSelectedTab(1);
        break;
      case "staff":
        setSelectedTab(2);
        break;
      case "teacher":
        setSelectedTab(3);
        break;
      case "student":
        setSelectedTab(4);
        break;
      case "parent":
        setSelectedTab(5);
        break;
      case "owner":
        setSelectedTab(6);
        break;
      default:
        setSelectedTab(0);
        break;
    }
  }, [state.membersFilter]);
  //
  const handleTabChange = useCallback(
    (selectedTabIndex) => {
      var selectedType = "";
      switch (selectedTabIndex) {
        case 0:
          selectedType = "all";
          break;
        case 1:
          selectedType = "admin,owner";
          break;
        case 2:
          selectedType = "staff";
          break;
        case 3:
          selectedType = "teacher";
          break;
        case 4:
          selectedType = "student";
          break;
        case 5:
          selectedType = "parent";
          break;
        case 6:
          selectedType = "owner";
          break;
        default:
          selectedType = "all";
          break;
      }
      setFilter("type", selectedType);
    },
    [setFilter]
  );
  //
  const queryList = membersAPI.useGetList(
    schoolId,
    accessToken,
    page,
    pageSize,
    JSON.parse(state.membersFilter)
  );
  //
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //
  const tabs = [
    { label: "Tous", value: 0 },
    { label: "Administration", value: 1 },
    { label: "Personnels de l'école", value: 2 },
    { label: "Enseignants", value: 3 },
    { label: "Elèves", value: 4 },
    { label: "Parents d'élèves", value: 5 },
    { label: "Propriétaires", value: 6 },
  ];
  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <MeaButton
          label="Ajouter un membre"
          icon="pi pi-plus"
          className="p-button mr-2 action"
          onClick={() => {
            createModalRef.current.show(() => {
              queryList.refetch();
            });
          }}
          data-pr-tooltip="Nouveau membre"
          permission={PERMISSION_SCHOOL_MEMBERS.CREATE}
        />
      )}
      <span className="p-input-icon-left mr-2 ">
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText
            className="p-inputtext-sm"
            value={JSON.parse(state.membersFilter)?.name}
            onChange={(e) => setFilter("name", e.target.value)}
            placeholder="Chercher un membre"
          />
        </IconField>

      </span>
    </div>
  );
  //
  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <ConfirmPopup />
      <CreateCourseModal ref={createModalRef} schoolId={schoolId} trainingId={trainingId} />
      <div className="grid">
        <div className="col-2 hidden lg:block " >
          <ListBox value={selectedTab} options={tabs} optionLabel="label" onChange={(e) => handleTabChange(e.value)} />
        </div>
        <div className="col-12 block lg:hidden">
          <Dropdown className="w-full" value={selectedTab} options={tabs} optionLabel="label" onChange={(e) => handleTabChange(e.value)} />
        </div>
        <div className="col-12 lg:col-10">
          <MeaDataTable
            query={queryList}
            serviceAPI={membersAPI}
            schoolId={schoolId}
            trainingId={trainingId}
            accessToken={accessToken}
            names={{
              pagination: "members",
              singular: "membre",
              plural: "membres",
            }}
            startToolbarTemplate={startToolbarTemplate}
            showDeleteButton={hasPermission(PERMISSION_SCHOOL_MEMBERS.DELETE)}
            showFilterButton={false}
            showFilter={true}
            setPage={setPage}
            setPageSize={setPageSize}
          >
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3rem" }}
            ></Column>
            <Column
              header="Membre"
              body={(member) => <MeaMemberAvatar member={member} permission={PERMISSION_SCHOOL_MEMBERS.GET} />}
            ></Column>
            <Column
              header="E-mail"
              field="email"
              filter
              showFilterMenu={false}
              showClearButton={true}
              filterElement={(options) => <InputText
                value={JSON.parse(state.membersFilter)?.email}
                onChange={(e) => setFilter("email", e.target.value)}
              />}
            ></Column>
            <Column
              header="Téléphone"
              field="phone"
              filter
              showFilterMenu={false}
              showClearButton={true}
              filterElement={(options) => <InputText
                value={JSON.parse(state.membersFilter)?.phone}
                onChange={(e) => setFilter("phone", e.target.value)}
              />}
            ></Column>
            <Column
              header="Roles"
              body={(member) => {
                return (
                  <div className=" flex flex-wrap justify-content-start gap-1">
                    {member.is_owner && (
                      <Tag value="Propriétaire" severity="info" rounded></Tag>
                    )}
                    {member.is_admin && (
                      <Tag value="Administration" severity="info" rounded></Tag>
                    )}
                    {member.is_staff && (
                      <Tag value="Secrétariat" severity="info" rounded></Tag>
                    )}
                    {member.is_teacher && (
                      <Tag value="Enseignant(e)" severity="info" rounded></Tag>
                    )}
                    {member.is_parent && (
                      <Tag value="Parent" severity="info" rounded></Tag>
                    )}
                    {member.is_student && (
                      <Tag value="Elève" severity="info" rounded></Tag>
                    )}
                  </div>
                );
              }}
            ></Column>
            <Column
              header="Dernière activité"
              body={(member) => {
                return (
                  (member?.account_id ? (member.last_activity_at ? (<span>
                    {new Date(member.last_activity_at).toLocaleString("fr-FR", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>) : (<span>Jamais connecté!</span>)) : (<MeaButton outlined label="Inviter" size="small" severity="secondary" permission={PERMISSION_SCHOOL_MEMBERS.UPDATE} onClick={(event) => {

                    confirmPopup({
                      target: event.currentTarget,
                      message: 'Voulez-vous vraiment inviter ce membre à se connecter à l\'école?',
                      icon: 'pi pi-exclamation-triangle',
                      defaultFocus: 'accept',
                      accept: () => {
                        membersAPI.Invite(schoolId, accessToken, member.id).then((response) => {
                          toast.current.show({
                            severity: 'success', summary: 'Succès', detail: " Invité!", life: 3000
                          });
                          queryList.refetch();
                        }).catch((error) => {

                          toast.current.clear();
                          toast.current.show({
                            severity: "error",
                            summary: "Erreur",
                            detail: "Erreur! " + error,
                          });
                        });
                      }
                    })
                  }} />))
                )
              }} >
            </Column>
          </MeaDataTable>
        </div>
      </div>
    </>
  );
});

export default MembersListComponent;
